import * as $ from 'jquery';
import * as _ from 'underscore';
import * as React from 'react';

import SelectField from '../../../../_common/platform/ts/SelectField';
import NumberField from '../../../../_common/platform/ts/NumberField';
import StringField from '../../../../_common/platform/ts/StringField';
import BooleanField from '../../../../_common/platform/ts/BooleanField';
import CKEditPopupField from '../../../../_common/platform/tsx/CKEditPopupField';
//import TimeZoneOffsetField = require('../../../../_common/platform/ts/TimeZoneOffsetField');
import UtcOffsetField from '../../../../_common/platform/ts/UtcOffsetField';
import { validators } from '../../../../_common/platform/ts/validators';

import * as appTheme from '../../../../_common/platform/ts/appTheme';
import * as Globalization from '../../../../_common/platform/ts/Globalization';

import { ColorMappingForNumericField } from '../../../../_common/platform/ts/ColorMappingForNumericField';
import { validators as validatorsColorScales } from '../../../../_common/platform/ts/validatorsColorScales';

import { DiscreteMappingField } from '../../../../_common/platform/ts/DiscreteMappingField';

import { EntityColorSelect } from '../../../../_common/platform/ts/EntityColorSelect'; //LL: 21.07.20
import { EntityColorSelect as EntityColorSelectComponent } from '../../../../_common/platform/tsx/EntityColorSelect';

import { MappingField } from '../../../../_common/platform/ts/MappingField';

import { PalettesField } from '../../../../_common/platform/ts/PalettesField';

import { themeVars } from './themeConstants';

import { CKEDITOR_CONFIG_STATIC } from '../../../../_common/platform/ts/Utilities';
import GlobalState from '../../../../_common/platform/ts/globalStates/GlobalState';
import { WidgetData } from '../../../../_common/platform/ts/WidgetData';

import ConfigEdit from '../../../../pdc-widget-html/src/ts/react/ConfigEdit'; //'./ConfigEdit';

import { ResourceBrowser } from '../../../../pdc-widget-resource-manager/src/ts/react/ResourceBrowser';

import * as CKEditorPdcWidget from '../../../../pdc-widget-html/src/ts/ckeditor/pdc-widget'; // ../ckeditor/pdc-widget';
import { FormatChooserValueSelectorField } from '../../../../_common/platform/tsx/formatChooser/FormatChooserValueSelector';
import { ATTRIBUTE_TYPES, TIME_PART_TYPES } from '../../../../_common/platform/ts/ConfigurationConstants';

//LL: 04.02.20
function isHiddenMappingsLL(levels, widgetParams) {
    //let tryMappingsLL = true;
    let tryMappingsLL = false;
    return !tryMappingsLL;
}

const _init = [];

function getEditorDependencies(glob) {
    return {
        WidgetData,
        React,
        $,
        ConfigEdit,
        ResourceBrowser,
        glob,
        CKEditorPdcWidget,
        GlobalState
    };
}

export function init(glob) {
    if (_.indexOf(_init, glob) !== -1) {
        return;
    }

    appTheme.registerSections([
        {
            id: themeVars.section_formats,
            name: 'Formats and Region',
            themeType: 'Formats',
            visibility: ['application', 'workspace', 'widget', 'inline']
        }
    ]);

    appTheme.registerSections([
        {
            id: 'timeZone',
            name: 'Time Zone',
            themeType: 'TimeZone',
            visibility: ['application', 'workspace', 'widget']
        }
    ]);

    appTheme.registerSections([
        {
            id: 'printing',
            name: 'Print',
            themeType: 'Print',
            visibility: ['application', 'workspace', 'widget']
        }
    ]);

    appTheme.registerSections([
        {
            id: 'printing-page-layout',
            name: 'Page Size and Layout',
            parent: 'printing',

            themeType: 'Print',
            visibility: ['application', 'workspace', 'pdc-widget-html', 'pdc-widget-cards2']
        }
    ]);

    appTheme.registerSections([
        {
            id: 'printing-cover-page',
            name: 'Front Page',
            parent: 'printing',
            themeType: 'Print',
            visibility: ['application', 'workspace', 'widget']
        }
    ]);

    appTheme.registerSections([
        {
            id: 'printing-headers-footers',
            name: 'Header and Footer',
            parent: 'printing',
            themeType: 'Print',
            visibility: ['application', 'workspace', 'widget']
        }
    ]);

    //LL: 28.01.20: own section
    appTheme.registerSections([
        {
            id: 'palettes',
            name: 'Palettes',
            //parent: 'colorMapping',
            themeType: 'Palettes',
            visibility: ['application', 'workspace', 'widget']
        }
    ]);

    //LL: 21.07.20: move here 'Entity Color' (defined in pdc-widget-entity-model-editor/ts/themes/main)
    //              So, no duplication now
    //LL: 28.01.20: rename to 'Mappings'
    //LL: 17.09.19:  rename by Leo's request, don't forget in pdc-widget-entity-model-editor
    //LL: parent node for 'ColorScales' and 'Entity Color' (defined in pdc-widget-entity-model-editor/ts/themes/main)
    //     duplicate there, so parent already exists
    appTheme.registerSections([
        {
            id: 'colorMapping',
            name: 'Mappings', //'Color and Color Mappings',  //'Color and Mappings', // 'Color Mapping',
            themeType: 'ColorMapping',
            visibility: ['application', 'workspace', 'widget']
        }
    ]);

    //LL: 21.07.20: move here 'Entity Color' (defined in pdc-widget-entity-model-editor/ts/themes/main)
    //              So, no duplication now
    appTheme.registerSections([
        {
            id: 'entities-model',
            //name: 'Entity Color',
            //name: 'Color Lookup Tables', //LL: 06.02.18: Leo's request
            name: 'Colors for Entities and Attributes', //LL: 30.11.19: Leo's request 'Specifying Colors for Entities and Attributes'
            parent: 'colorMapping', //LL: 06.02.18
            explanation: 'Mapping individual Attribute Values to Colors', //LL: 06.02.18
            themeType: 'Entity Color',
            visibility: ['application', 'workspace', 'widget']
        }
    ]);

    appTheme.registerSections([
        {
            id: 'colorScales',
            name: 'Color Scales',
            parent: 'colorMapping',

            //explanation: "Mapping numbers in a range to a range of colors",
            explanation: 'Mapping Values (numbers, dates, etc) in a range to a range of colors',

            themeType: 'ColorScales',
            visibility: ['application', 'workspace', 'widget']
        }
    ]);

    //LL: 28.01.20: to 'colorMapping' section
    appTheme.registerSections([
        {
            id: 'discreteMapping',
            name: 'Discrete Mappings',
            themeType: 'DiscreteMapping',
            parent: 'colorMapping',
            visibility: ['application', 'workspace', 'widget']
        }
    ]);

    //LL: 24.12.19:
    appTheme.registerSections([
        {
            id: 'mapping',
            name: 'Mappings LL: DO NOT USE !',
            themeType: 'Mapping',
            hiddenOptions: { hiddenFunction: isHiddenMappingsLL }, //LL: 04.02.20
            visibility: ['application', 'workspace', 'widget']
        }
    ]);

    appTheme.registerVars([
        {
            id: 'widget-culture-selector',
            param: new SelectField(glob, 'Region', [], 'default', {
                values: Globalization.getCultureCodesWithDefault(),
                display: Globalization.getCultureNamesWithDefault()
            }),
            section: themeVars.section_formats
        },
        {
            id: 'widget-culture-first-week-day',
            param: new SelectField(
                glob,
                'First Day of Week',
                [],
                function (theme) {
                    return Globalization.getFirstDay(Globalization.getWidgetCulture(theme));
                },
                {
                    values: Globalization.WEEK_DAY_ABBREVIATIONS_ISO,
                    display: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
                }
            ),
            section: themeVars.section_formats,
            deps: ['widget-culture-selector']
        },
        {
            id: themeVars.currencySelector,
            param: new StringField(
                glob,
                'Currency',
                [validators.string.notEmpty, validators.string.currency3symbols],
                'EUR'
            ),
            section: themeVars.section_formats
        },
        {
            id: themeVars.fiscalFirstMonth,
            param: new SelectField(glob, 'Fiscal First Month', [], 1, {
                values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                display: [
                    'January',
                    'February',
                    'March',
                    'April',
                    'May',
                    'June',
                    'July',
                    'August',
                    'September',
                    'October',
                    'November',
                    'December'
                ]
            }),
            section: themeVars.section_formats
        },
        {
            id: themeVars.formats_boolean,
            param: new FormatChooserValueSelectorField(glob, 'Boolean', {
                attributeType: ATTRIBUTE_TYPES.BOOLEAN
            }),
            section: themeVars.section_formats
        },
        {
            id: themeVars.formats_date,
            param: new FormatChooserValueSelectorField(glob, 'Date', {
                attributeType: ATTRIBUTE_TYPES.DATE
            }),
            section: themeVars.section_formats
        },
        {
            id: themeVars.formats_datetime,
            param: new FormatChooserValueSelectorField(glob, 'Datetime', {
                attributeType: ATTRIBUTE_TYPES.DATETIME
            }),
            section: themeVars.section_formats
        },
        {
            id: themeVars.formats_fiscalYear,
            param: new FormatChooserValueSelectorField(glob, 'Fiscal Year', {
                attributeType: ATTRIBUTE_TYPES.DATETIME,
                timePart: TIME_PART_TYPES.FISCAL_YEAR
            }),
            section: themeVars.section_formats
        },
        {
            id: themeVars.formats_time,
            param: new FormatChooserValueSelectorField(glob, 'Time', {
                attributeType: ATTRIBUTE_TYPES.TIME
            }),
            section: themeVars.section_formats
        },
        {
            id: themeVars.use24HoursFormat,
            param: new BooleanField(glob, '24-Hour Time', [], (theme) => {
                return Globalization.getPrefferedTimeFormat(Globalization.getWidgetCulture(theme)) === 'H';
            }),
            section: themeVars.section_formats,
            deps: ['widget-culture-selector']
        },
        {
            id: themeVars.formats_integer,
            param: new FormatChooserValueSelectorField(glob, 'Integer', {
                attributeType: ATTRIBUTE_TYPES.INTEGER
            }),
            section: themeVars.section_formats
        },
        {
            id: themeVars.formats_real,
            param: new FormatChooserValueSelectorField(glob, 'Real', {
                attributeType: ATTRIBUTE_TYPES.REAL
            }),
            section: themeVars.section_formats
        }
    ]);

    appTheme.registerVars([
        {
            id: themeVars.utcOffsetSelector,
            param: new UtcOffsetField(glob, 'Time Zone', [], null, {
                theme: appTheme.getThemeObj(null)
            }),
            section: 'timeZone'
        },

        {
            id: 'pdc-widget-html-document-mode',
            param: new SelectField(glob, 'Document Mode', [], 'Article', {
                values: ['Article', 'Document'],
                display: ['Inline Mode', 'Print Preview Mode']
            }),
            section: 'printing-page-layout'
        },

        {
            id: 'pdc-widget-html-page-size',
            param: new SelectField(glob, 'Page Size', [], 'A4', {
                values: ['A0', 'A1', 'A2', 'A3', 'A4', 'A5', 'Legal', 'Letter', 'Tabloid'],
                display: ['A0', 'A1', 'A2', 'A3', 'A4', 'A5', 'Legal', 'Letter', 'Tabloid']
            }),
            section: 'printing-page-layout'
        },

        {
            id: 'pdc-widget-html-page-orientation',
            param: new SelectField(glob, 'Page Orientation', [], 'portrait', {
                values: ['portrait', 'landscape'],
                display: ['Portrait', 'Landscape']
            }),
            section: 'printing-page-layout'
        },

        //LL: 12.01.21:
        {
            id: 'pdc-widget-html-reset-layout-after-config',
            param: new BooleanField(glob, 'Reset local Page Layout after Saving of updated Configuration', [], true),
            section: 'printing-page-layout'
        },

        {
            id: 'widget-show-title-pdf',
            param: new BooleanField(glob, 'Show Title', [], false),
            section: 'printing'
        },
        {
            id: 'widget-show-clock-pdf',
            param: new BooleanField(glob, 'Show Date', [], false),
            section: 'printing'
        },
        {
            id: 'widget-show-page-pdf',
            param: new BooleanField(glob, 'Show Page Numbers', [], false),
            section: 'printing'
        },
        {
            id: 'print-show-page-header',
            param: new BooleanField(glob, 'Show Page Header', [], false),
            section: 'printing-headers-footers'
        },

        {
            id: 'print-page-header',
            param: new CKEditPopupField(glob, 'Page Header', [], '', {
                editorConfig: $.extend(true, {}, CKEDITOR_CONFIG_STATIC, {
                    width: 600,
                    height: 400
                })
            }),

            section: 'printing-headers-footers'
        },

        {
            id: 'print-show-page-footer',
            param: new BooleanField(glob, 'Show Page Footer', [], false),

            section: 'printing-headers-footers'
        },

        {
            id: 'print-page-footer',
            param: new CKEditPopupField(glob, 'Page Footer', [], '', {
                editorConfig: $.extend(true, {}, CKEDITOR_CONFIG_STATIC, {
                    width: 600,
                    height: 400
                })
            }),

            section: 'printing-headers-footers'
        },

        {
            id: 'print-add-cover-page',
            param: new BooleanField(glob, 'Add Front Page', [], false),

            section: 'printing-cover-page'
        },

        {
            id: 'print-cover-page-content',
            param: new CKEditPopupField(glob, 'Front Page', [], '', {
                editorConfig: $.extend(true, {}, CKEDITOR_CONFIG_STATIC, {
                    width: 600,
                    height: 400,
                    extraPlugins: 'pdc-widget-aql,pdc-widget,pdc-resource-manager',
                    toolbar: [{ name: 'pdc', items: ['pdc-widget', 'pdc-widget-aql'] }]
                }),
                dependencies: getEditorDependencies(glob)
            }),

            section: 'printing-cover-page'
        },

        //LL: 21.07.20: move here 'Entity Color' (defined in pdc-widget-entity-model-editor/ts/themes/main)
        //              So, no duplication now
        {
            id: themeVars.entityAttributeMapping, // 'entities-model-color-mapping',
            param: new EntityColorSelect(
                glob,
                'Color Mapping',
                [],
                function (theme) {
                    return {};
                },
                {}
            ),
            section: 'entities-model',
            isArray: true, //LL: 09.10.20
            merger: EntityColorSelectComponent.themeMerger //LL: 11.10.20  was here, moved
        },

        {
            id: themeVars.color_scales_set, //'color-scales-set-new',
            param: new ColorMappingForNumericField(
                glob,
                'Color Scales:',
                [
                    validatorsColorScales.chartParams.customStyles_shouldHaveNames,
                    validatorsColorScales.chartParams.customStyles_namesUnique,
                    validatorsColorScales.chartParams.colorMappingForNumeric_MinMax
                ],
                null,
                {
                    noTitle: true //LL: to save space at the top of field;  title:'' is not enough
                }
            ),
            isArray: true, //LL: 23.04.19: interface IVariable in appTheme    NOT USED ?
            merger: appTheme.mergerForArrays,
            section: 'colorScales'
        },

        {
            id: themeVars.discreteMapping_set,
            param: new DiscreteMappingField(
                glob,
                'Discrete Mappings:',
                [
                    validatorsColorScales.chartParams.customStyles_shouldHaveNames,
                    validatorsColorScales.chartParams.customStyles_namesUnique
                ],
                null,
                {
                    noTitle: true //LL: to save space at the top of field;  title:'' is not enough
                }
            ),
            isArray: true, //LL: interface IVariable in appTheme   NOT USED ?
            merger: appTheme.mergerForArrays,
            section: 'discreteMapping'
        },

        //LL: 24.12.19:  TRY
        {
            id: themeVars.mapping_set,
            param: new MappingField(
                glob,
                'Mappings:  DO NOT USE !',
                [
                    validatorsColorScales.chartParams.customStyles_shouldHaveNames,
                    validatorsColorScales.chartParams.customStyles_namesUnique
                ],
                null,
                {
                    noTitle: true //LL: to save space at the top of field;  title:'' is not enough
                }
            ),
            isArray: true, //LL: interface IVariable in appTheme   NOT USED ?
            merger: appTheme.mergerForArrays,
            section: 'mapping'
        },

        {
            id: themeVars.palette_set,
            param: new PalettesField(
                glob,
                'Palettes:',
                [
                    validatorsColorScales.chartParams.customStyles_shouldHaveNames,
                    validatorsColorScales.chartParams.customStyles_namesUnique
                ],
                null,
                {
                    noTitle: true //LL: to save space at the top of field;  title:'' is not enough
                }
            ),
            isArray: true, //LL: interface IVariable in appTheme   NOT USED ?
            merger: appTheme.mergerForArrays,
            section: 'palettes'
        }
    ]);

    _init.push(glob);
}
